import { loadingBarReducer as loadingBar } from 'react-redux-loading-bar';

import applicationProfile from './application-profile';
import locale from './locale';

import activate from 'app/modules/account/activate/activate.reducer';
import passwordReset from 'app/modules/account/password-reset/password-reset.reducer';
import password from 'app/modules/account/password/password.reducer';
import register from 'app/modules/account/register/register.reducer';
import administration from 'app/modules/administration/administration.reducer';
import userManagement from 'app/modules/administration/user-management/user-management.reducer';
import dashboardCompany from 'app/modules/dashboards/dashboard-company/dashboard-company.reducer';
import dashboardTruckImplement from 'app/modules/dashboards/dashboard-truck-implement/DashboardTruckImplement.reducer';
import inProductionButton from 'app/shared/components/do-not-show-in-production/in-production-button.reducer';
import authentication, { logoutSession } from './authentication';
import { combineReducers } from 'redux';

// prettier-ignore
import company from 'app/entities/company/company.reducer';
// prettier-ignore
import userCustom from 'app/entities/user-custom/user-custom.reducer';
// prettier-ignore
import truckImplement from 'app/entities/truck-implement/truck-implement.reducer';
// prettier-ignore
import sensor from 'app/entities/sensor/sensor.reducer';
// prettier-ignore
import sensorHardware from 'app/entities/sensor-hardware/sensor-hardware.reducer';
// prettier-ignore
import deviceSensor from 'app/entities/device-sensor/device-sensor.reducer';
// prettier-ignore
import device from 'app/entities/device/device.reducer';
// prettier-ignore
import deviceTruckImplement from 'app/entities/device-truck-implement/device-truck-implement.reducer';
// prettier-ignore
import alert from 'app/entities/alert/alert.reducer';
// prettier-ignore
import sensorData from 'app/entities/sensor-data/sensor-data.reducer';
// prettier-ignore
import sensorDataDaily from 'app/entities/sensor-data-daily/sensor-data-daily.reducer';
// prettier-ignore
import statisticMarkLine from 'app/entities/statistic-mark-line/statistic-mark-line.reducer';
// prettier-ignore
import alertActivation from 'app/entities/alert-activation/alert-activation.reducer';
// prettier-ignore
import userTruckImplement from 'app/entities/user-truck-implement/user-truck-implement.reducer';
// prettier-ignore
import virtualFenceCircle from 'app/entities/virtual-fence-circle/virtual-fence-circle.reducer';
// prettier-ignore
import vehiclePosition from 'app/entities/vehicle-position/vehicle-position.reducer';
// prettier-ignore
import virtualFenceCircleAlert from 'app/entities/virtual-fence-circle-alert/virtual-fence-circle-alert.reducer';
// prettier-ignore
import vehicleModel from 'app/entities/vehicle-model/vehicle-model.reducer';
// prettier-ignore
import part from 'app/entities/part/part.reducer';
// prettier-ignore
import place from 'app/entities/place/place.reducer';
// prettier-ignore
import maintenanceReview from 'app/entities/maintenance-review/maintenance-review.reducer';
// prettier-ignore
import maintenanceVehicle from 'app/entities/maintenance-vehicle/maintenance-vehicle.reducer';
// prettier-ignore
import maintenancePart from 'app/entities/maintenance-part/maintenance-part.reducer';
// prettier-ignore
import reportDailyVehicle from 'app/entities/report-daily-vehicle/report-daily-vehicle.reducer';
// prettier-ignore
import maintenanceControl from 'app/entities/maintenance-control/maintenance-control.reducer';
// prettier-ignore
import maintenanceControlCustom from 'app/entities/maintenance-control/maintenance-control-custom.reducer';
// prettier-ignore
import maintenanceVehicleCustom from 'app/modules/maintenance-vehicle-custom/maintenance-vehicle-custom.reducer';
// prettier-ignore
import maintenanceModel from 'app/entities/maintenance-model/maintenance-model.reducer';
// prettier-ignore
import sensorDataValues from 'app/shared/reducers/shared/sensor-data-values.reducer';
// prettier-ignore
import companyToken from 'app/entities/company-token/company-token.reducer';
// prettier-ignore
import deviceTruckImplementDTO from 'app/modules/dashboards/dashboard-truck-implement/components/truck-implement-devices-tab/device-truck-implement.reducer';
// prettier-ignore
import deviceSensorDTO from 'app/modules/dashboards/dashboard-truck-implement/components/truck-implement-devices-tab/sensor-truck-implement-device.reducer';
// prettier-ignore
import identificationCodeAlert from 'app/entities/identification-code-alert/identification-code-alert.reducer';
// prettier-ignore
import SensorHardwareDevice from 'app/modules/dashboards/dashboard-truck-implement/components/truck-implement-devices-tab/odometer-truck-implement-device.reducer';
// prettier-ignore
import tire from 'app/entities/tire/tire.reducer';
// prettier-ignore
import tireManufacturer from 'app/entities/tire-manufacturer/tire-manufacturer.reducer';
// prettier-ignore
import tireModel from 'app/entities/tire-model/tire-model.reducer';
// prettier-ignore
import tireTreadManufacturer from 'app/entities/tire-tread-manufacturer/tire-tread-manufacturer.reducer';
// prettier-ignore
import tireTreadModel from 'app/entities/tire-tread-model/tire-tread-model.reducer';
// prettier-ignore
import tireAlertSetting from 'app/entities/tire-alert-setting/tire-alert-setting.reducer';
// prettier-ignore
import tireTruckImplement from 'app/entities/tire-truck-implement/tire-truck-implement.reducer';
// prettier-ignore
import tireTruckImplementCustom from 'app/modules/tire-custom/tire-truckImplement-custom/tire-truck-implement-custom.reducer';
// prettier-ignore
import tireRotationCustom from 'app/modules/tire-custom/tire-truckImplement-custom/tire-rotation-custom.reducer';
// prettier-ignore
import tireGrooveCustom from 'app/modules/tire-custom/tire-groove-custom/tire-groove-custom.reducer';
// prettier-ignore
import tireIndicators from 'app/modules/tire-custom/tire-indicators/tire-indicators.reducer';
// prettier-ignore
import tireCpkDashboard from 'app/modules/tire-custom/tire-cpk/tire-cpk-dashboard.reducer';
// prettier-ignore
import tireDiscardDashboard from 'app/modules/tire-custom/tire-discard/tire-discard-dashboard.reducer';
// prettier-ignore
import truckDeviceStatus from 'app/entities/truck-device-status/truck-device-status.reducer';
// prettier-ignore
import truckDeviceStatusHistory from 'app/entities/truck-device-status-history/truck-device-status-history.reducer';
// prettier-ignore
import distanceTraveled from 'app/modules/indicators/traveled-distance/traveled-distance.reducer';
// prettier-ignore
import indicatorAlerts from 'app/modules/indicators/indicator-alert/indicator-alert.reducer';
// prettier-ignore
import indicatorBrakingIndex from 'app/modules/indicators/indicator-braking-index/indicator-braking-index.reducer';
// prettier-ignore
import indicatorBraking from 'app/modules/indicators/indicator-braking/indicator-braking.reducer';
// prettier-ignore
import indicatorSpeed from 'app/modules/indicators/indicator-speed/indicator-speed.reducer';
// prettier-ignore
import indicatorLoad from 'app/modules/indicators/indicator-load/indicator-load.reducer';
// prettier-ignore
import indicatorRss from 'app/modules/indicators/indicator-rss/indicator-rss.reducer';
// prettier-ignore
import indicatorAbs from 'app/modules/indicators/indicator-abs/indicator-abs.reducer';
// prettier-ignore
import indicatorTiresAlert from 'app/modules/indicators/indicator-alert-tires/indicator-alert-tires.reducer';
// prettier-ignore
import indicatorTires from 'app/modules/indicators/indicator-tires/indicator-tires.reducer';
// prettier-ignore
import inspectionItem from 'app/entities/inspection-item/inspection-item.reducer';
// prettier-ignore
import inspection from 'app/entities/inspection/inspection.reducer';
// prettier-ignore
import inspectionItemPerformed from 'app/entities/inspection-item-performed/inspection-item-performed.reducer';
// prettier-ignore
import inspectionHistory from 'app/entities/inspection-history/inspection-history.reducer';
// prettier-ignore
import gasSupply from 'app/entities/gas-supply/gas-supply.reducer';
// prettier-ignore
import scheduling from 'app/entities/scheduling/scheduling.reducer';
// prettier-ignore
import schedulingHistory from 'app/entities/scheduling-history/scheduling-history.reducer';
// prettier-ignore
import deviceCommunication from 'app/entities/device-communication/device-communication.reducer';
// prettier-ignore
import favoriteTruck from 'app/entities/favorite-truck/favorite-truck.reducer';
// prettier-ignore
import generatePdfState from 'app/modules/maintenance-vehicle-custom/pdf-generate.reducer';
// prettier-ignore
import representativeCompany from 'app/entities/representative-company/representative-company.reducer';
// prettier-ignore
import representativeTruckImplement from 'app/entities/representative-truck-implement/representative-truck-implement.reducer';
// prettier-ignore
import kpiData from 'app/entities/kpi-data/kpi-data.reducer';
// prettier-ignore
import kpiLastProcessed from 'app/entities/kpi-last-processed/kpi-last-processed.reducer';
// prettier-ignore
import indicator from 'app/entities/indicator/indicator.reducer';
// prettier-ignore
import indicatorData from 'app/entities/indicator-data/indicator-data.reducer';
// prettier-ignore
import virtualCoupling from 'app/modules/asset-classification/virtual-coupling/reducers/virtual-coupling.reducer';
// prettier-ignore
import driverAssignment from 'app/modules/driver-classification/assignment/reducers/driver-assignment.reducer';
// prettier-ignore
import driverControlTower from 'app/modules/driver-classification/dashboard/reducers/driver-control-tower.reducer';
// prettier-ignore
import controlTower from 'app/modules/asset-classification/dashboard/reducers/control-tower.reducer';
// prettier-ignore
import controlTowerScoreTable from 'app/modules/asset-classification/dashboard/reducers/score-table.reducer';
// prettier-ignore
import kpiPresetWeight from 'app/modules/asset-classification/preset-weight/components/kpi-preset-weight/kpi-preset-weight.reducer';
// prettier-ignore
import kpiConfWeight from 'app/modules/asset-classification/preset-weight/components/kpi-conf-weight/kpi-conf-weight.reducer';
// prettier-ignore
import kpiPresetWeightVehicle from 'app/modules/asset-classification/preset-weight/components/kpi-preset-weight-vehicle/kpi-preset-weight-vehicle.reducer';
// prettier-ignore
import presetWeight from 'app/modules/asset-classification/preset-weight/preset-weight.reducer';

/* jhipster-needle-add-reducer-import - JHipster will add reducer here */
// prettier-ignore
import blockScreen from 'app/entities/block-screen/block-screen.reducer';
// prettier-ignore
import fifthWheel from 'app/entities/fifth-wheel/fifth-wheel.reducer';
// prettier-ignore
import fifthWheelConnection from 'app/entities/fifth-wheel-connection/fifth-wheel-connection.reducer';
// prettier-ignore
import fifthWheelHistory from 'app/entities/fifth-wheel-history/fifth-wheel-history.reducer';
// prettier-ignore
import vehiclePositionLast from 'app/entities/vehicle-position-last/vehicle-position-last.reducer';
// prettier-ignore
import kpiConfScore from 'app/modules/asset-classification/preset-company/components/kpi-conf-score.reducer';
// prettier-ignore
import kpiPreset from 'app/modules/asset-classification/preset-vehicle/components/kpi-preset/kpi-preset.reducer';
// prettier-ignore
import kpiConf from 'app/modules/asset-classification/preset-vehicle/components/kpi-conf/kpi-conf.reducer';
// prettier-ignore
import kpiPresetVehicle from 'app/modules/asset-classification/preset-vehicle/components/kpi-preset-vehicle/kpi-preset-vehicle.reducer';
// prettier-ignore
import allowedCompanies from 'app/entities/allowed-companies/allowed-companies.reducer';
// prettier-ignore
import truckOdometer from 'app/shared/reducers/shared/truck-odometer.reducer'
// prettier-ignore
import scoreHistory from 'app/modules/asset-classification/dashboard/reducers/score-history.reducer';
// prettier-ignore
import fleetIndicatorsFuel from 'app/modules/indicators/indicator-fuel-consumption/indicator-fuel-consumption.reducer';
// prettier-ignore
import reports from 'app/modules/reports/reports.reducer';
// prettier-ignore
import truckGroup from 'app/entities/truck-group/truck-group.reducer';
// prettier-ignore
import virtualFencePolygon from 'app/entities/virtual-fence-polygon/virtual-fence-polygon.reducer';
// prettier-ignore
import virtualFenceList from 'app/entities/virtual-fence/virtual-fence-list.reducer';
// prettier-ignore
import logisticRoute from 'app/entities/logistic-route/logistic-route.reducer';
// prettier-ignore
import routeEventAlert from 'app/entities/route-event-alert/route-event-alert.reducer';
// prettier-ignore
import cameraEvent from 'app/entities/camera-event/camera-event.reducer';
// prettier-ignore
import cameraDevice from 'app/entities/camera-device/camera-device.reducer';

const appReducer = combineReducers({
  authentication,
  locale,
  applicationProfile,
  administration,
  userManagement,
  register,
  activate,
  passwordReset,
  dashboardCompany,
  dashboardTruckImplement,
  password,
  company,
  userCustom,
  truckImplement,
  sensor,
  sensorHardware,
  deviceSensor,
  device,
  deviceTruckImplement,
  alert,
  truckGroup,
  virtualFencePolygon,
  virtualFenceList,
  sensorData,
  sensorDataDaily,
  statisticMarkLine,
  alertActivation,
  inProductionButton,
  userTruckImplement,
  virtualFenceCircle,
  vehiclePosition,
  virtualFenceCircleAlert,
  vehicleModel,
  part,
  place,
  maintenanceReview,
  maintenanceVehicle,
  maintenancePart,
  reportDailyVehicle,
  maintenanceControl,
  maintenanceControlCustom,
  maintenanceVehicleCustom,
  maintenanceModel,
  sensorDataValues,
  companyToken,
  deviceTruckImplementDTO,
  deviceSensorDTO,
  identificationCodeAlert,
  truckDeviceStatus,
  truckDeviceStatusHistory,
  SensorHardwareDevice,
  tire,
  tireManufacturer,
  tireModel,
  tireTreadManufacturer,
  tireTreadModel,
  tireAlertSetting,
  tireTruckImplement,
  tireTruckImplementCustom,
  tireRotationCustom,
  tireGrooveCustom,
  tireIndicators,
  tireCpkDashboard,
  tireDiscardDashboard,
  distanceTraveled,
  indicatorBraking,
  indicatorBrakingIndex,
  indicatorAlerts,
  indicatorSpeed,
  indicatorLoad,
  indicatorRss,
  indicatorAbs,
  indicatorTiresAlert,
  indicatorTires,
  inspectionItem,
  inspection,
  inspectionItemPerformed,
  inspectionHistory,
  deviceCommunication,
  favoriteTruck,
  generatePdfState,
  representativeCompany,
  representativeTruckImplement,
  kpiData,
  kpiLastProcessed,
  indicator,
  indicatorData,
  fifthWheel,
  fifthWheelConnection,
  fifthWheelHistory,
  vehiclePositionLast,
  gasSupply,
  scheduling,
  schedulingHistory,
  blockScreen,
  allowedCompanies,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
  loadingBar,
  virtualCoupling,
  driverAssignment,
  driverControlTower,
  controlTower,
  controlTowerScoreTable,
  kpiConfScore,
  kpiPreset,
  kpiConf,
  kpiPresetVehicle,
  truckOdometer,
  kpiPresetWeight,
  kpiConfWeight,
  kpiPresetWeightVehicle,
  presetWeight,
  scoreHistory,
  fleetIndicatorsFuel,
  reports,
  logisticRoute,
  routeEventAlert,
  cameraEvent,
  cameraDevice,
});

// Reset the state of a redux store
const rootReducer = (state, action) => {
  if (action.type === logoutSession.type) {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
